// file: com/patronat/top/ui/molecules/status/StatusBadge.kt
package com.patronat.top.ui.molecules.status

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.*

enum class BadgeStyle(
    val bgColor: Color,
    val contentColor: Color,
    val borderColor: Color
) {
    ACTIVE(
        bgColor = StatusActiveBg,
        contentColor = StatusActiveContent,
        borderColor = StatusActiveContent
    ),

    INACTIVE(
        bgColor = MineShaft50,
        contentColor = MineShaft600,
        borderColor = MineShaft200
    ),

    WARNING(
        bgColor = Primary100,
        contentColor = Primary600,
        borderColor = MineShaft200
    ),

    ERROR(
        bgColor = Error100,
        contentColor = Error600,
        borderColor = Error200
    )
}

data class StatusBadgeColors(
    val bgColor: Color,
    val contentColor: Color,
    val borderColor: Color
)

@Composable
fun StatusBadge(
    text: String,
    style: BadgeStyle,
    modifier: Modifier = Modifier,
    showDot: Boolean = true,
    minHeight: Dp = Dp.Unspecified,
    cornerRadius: Dp = 50.dp,
    borderWidth: Dp = 1.dp,
    horizontalPadding: Dp = 12.dp,
    verticalPadding: Dp = 6.dp
) {
    StatusBadge(
        text = text,
        colors = StatusBadgeColors(
            bgColor = style.bgColor,
            contentColor = style.contentColor,
            borderColor = style.borderColor
        ),
        modifier = modifier,
        showDot = showDot,
        minHeight = minHeight,
        cornerRadius = cornerRadius,
        borderWidth = borderWidth,
        horizontalPadding = horizontalPadding,
        verticalPadding = verticalPadding
    )
}

@Composable
fun StatusBadge(
    text: String,
    colors: StatusBadgeColors,
    modifier: Modifier = Modifier,
    showDot: Boolean = true,
    minHeight: Dp = Dp.Unspecified,
    cornerRadius: Dp = 50.dp,
    borderWidth: Dp = 1.dp,
    horizontalPadding: Dp = 12.dp,
    verticalPadding: Dp = 6.dp
) {
    Row(
        modifier = modifier
            .border(
                width = borderWidth,
                color = colors.borderColor,
                shape = RoundedCornerShape(cornerRadius)
            )
            .background(colors.bgColor, RoundedCornerShape(cornerRadius))
            .defaultMinSize(minHeight = minHeight)
            .padding(horizontal = horizontalPadding, vertical = verticalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (showDot) {
            Canvas(modifier = Modifier.size(6.dp)) {
                drawCircle(color = colors.contentColor)
            }

            Spacer(modifier = Modifier.width(8.dp))
        }

        Text(
            text = text,
            style = BadgeTextStyle,
            color = colors.contentColor
        )
    }
}
